export const mapInitials = (name: string): string => {
  return (
    name
      .match(/(^\S\S?|\b\S)?/g)
      ?.join('')
      .match(/(^\S|\S$)?/g)
      ?.join('')
      .toUpperCase() || '-'
  )
}
